module.exports = __webpack_public_path__ + "static/media/step3.76b44580.png";